import type { ReactNode } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { Button } from '@launchpad-ui/components';

interface InlineSelectTriggerProps<T extends object> {
  hasSelection: boolean;
  selectedItem: T | null;
  emptyTrigger?: ReactNode;
  selectedTrigger?: (selectedItem: T) => ReactNode;
}

export function InlineSelectTrigger<T extends object>({
  hasSelection,
  selectedItem,
  emptyTrigger,
  selectedTrigger,
}: InlineSelectTriggerProps<T>) {
  if (!hasSelection) {
    return (
      emptyTrigger || (
        <Button variant="minimal" size="small">
          {msg('ui.inlineSelect.placeholder')}
        </Button>
      )
    );
  }

  if (selectedTrigger && selectedItem) {
    return selectedTrigger(selectedItem);
  }

  // Default selected trigger
  return (
    <Button variant="minimal" size="small">
      {selectedItem
        ? 'name' in selectedItem && typeof selectedItem.name === 'string'
          ? selectedItem.name
          : String(selectedItem)
        : 'Selected'}
    </Button>
  );
}
